import { Link } from 'components/data_display'
import { auxFieldName } from 'constants/Responses'
import { Button } from 'components/forms/components'

export const basicColumns = [
    {
        field: "actions",
        type: 'actions',
        headerName: "Acciones",
        minWidth: 200,
        getActions: (params) => [<Link to={"" + params.row.id}><Button size={"small"}>Ver</Button></Link>, <Link to={"" + params.row.id + "/editar"}><Button size={"small"} variant={"outlined"}>Editar</Button></Link>]
    },

    { field: "id_alumno", headerName: "ID Alumn.", maxWidth: 65 },

]

export const columnsAlumnosColegios = [
    { field: "colegio",       headerName: "Colegio",  minWidth: 100, flex: 1, valueGetter: (params) => { return params.row.colegio?.nombre } },
    { field: "alumno",        headerName: "Alumno",   minWidth: 100, flex: 1, valueGetter: (params) => { 
        return params.row.alumno?.nombre + " " + params.row.alumno?.apellido1 + " " + params.row.alumno?.apellido2
    }},
    { field: "curso_escolar", headerName: "Año",      minWidth: 100, valueGetter: (params) => (params.row.curso_escolar?.valor ?? "")},
    { field: "curso_colegio", headerName: "Curso",    maxWidth: 100, valueGetter: (params) => (params.row.curso_colegio?.valor ?? "")},
]

export const columnsGrupoColegio = [
    { field: "grupo_colegio", headerName: "Grupo",    minWidth: 100, flex: 1 },
    { field: "alumno",        headerName: "Alumno",    minWidth: 100, flex: 1 },
    { field: "colegio",       headerName: "Colegio",  minWidth: 100, flex: 1 },
    { field: "curso_escolar", headerName: "Año",      minWidth: 100},
    { field: "curso_colegio", headerName: "Curso",    maxWidth: 100},
]

export const columnsGrupoCL = [
    { field: "grupo_colegio", headerName: "Grupo",    minWidth: 100, flex: 1 },
    { field: "alumno",        headerName: "Alumno",    minWidth: 100, flex: 1 },
    { field: "colegio",       headerName: "Colegio",  minWidth: 100, flex: 1 },
    { field: "curso_escolar", headerName: "Año",      minWidth: 100},
    { field: "curso_colegio", headerName: "Curso",    maxWidth: 100},
]